import { KeyValue } from './index';
export const ErrorMessage: KeyValue = {
  ERROR_CODE_40000: '예약이 존재하지 않습니다.',
  ERROR_CODE_40001: '트리모 메일 내 확약서가 존재하지 않습니다.',
};
